module.exports = __webpack_public_path__ + "static/assets/4ba387ca5a24931acbcca652a38563b8.png";